import { FC } from 'react'
import { SvgComponent } from '@platform/ui'
import cn from 'classnames'
import styles from './Attention.module.scss'

type Props = {
  message: string
  onlyMobile?: boolean
}
export const Attention: FC<Props> = ({ message, onlyMobile }) => {
  return (
    <div
      className={cn(styles.attention, {
        [styles.onlyMobile]: onlyMobile,
      })}
    >
      <div className={styles.attentionIcon}>
        <SvgComponent name="InformationInCircleMediumFilled" />
      </div>
      {message}
    </div>
  )
}
